 import React, { useEffect, useRef, useState } from "react";


type Image = {
  url: string;
  name: string;
  description: string;
};

interface ImageCarouselProps {
  images: Image[];
}
/*
const ImageCarousel: React.FC<ImageCarouselProps> = ({ images }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [visibleCount, setVisibleCount] = useState(4);

  useEffect(() => {
    const updateVisibleCount = () => {
      if (window.innerWidth <= 480) setVisibleCount(1);
      else if (window.innerWidth <= 768) setVisibleCount(2);
      else setVisibleCount(4);
    };

    updateVisibleCount();
    window.addEventListener("resize", updateVisibleCount);
    return () => window.removeEventListener("resize", updateVisibleCount);
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prev) =>
        (prev + visibleCount) % images.length
      );
    }, 3000);
    return () => clearInterval(interval);
  }, [visibleCount, images.length]);

  const visibleImages = images.slice(currentIndex, currentIndex + visibleCount);
  const overflow = currentIndex + visibleCount > images.length;

  const renderImages = overflow
    ? [...images.slice(currentIndex), ...images.slice(0, (currentIndex + visibleCount) % images.length)]
    : visibleImages;

  return (
    <div className="carousel-container">
      <div className="carousel-track">
        {renderImages.map((img, idx) => (
          <div className="carousel-item" key={`${img.name}-${idx}`}>
            <div className="image-wrapper">
                <img src={img.url} alt={img.name} />
            </div>
            <div className="caption">
              <h3>{img.name}</h3>
              <p>{img.description}</p> 
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ImageCarousel; */


const ImageCarousel: React.FC<ImageCarouselProps> = ({ images }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [visibleCount, setVisibleCount] = useState(4);
  const [maxHeight, setMaxHeight] = useState(200);
  const containerRef = useRef(null);
  const imageRefs = useRef<(HTMLImageElement | null)[]>([]);

  // Detecta quantas imagens devem ser mostradas conforme o tamanho da tela
  useEffect(() => {
    const updateVisibleCount = () => {
      if (window.innerWidth <= 480) setVisibleCount(1);
      else if (window.innerWidth <= 768) setVisibleCount(2);
      else setVisibleCount(4);
    };

    updateVisibleCount();
    window.addEventListener("resize", updateVisibleCount);
    return () => window.removeEventListener("resize", updateVisibleCount);
  }, []);

  // Animação automática
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + visibleCount) % images.length);
    }, 3000);
    return () => clearInterval(interval);
  }, [visibleCount, images.length]);

  // Define altura máxima com base nas imagens visíveis
  useEffect(() => {
    if (imageRefs.current.length > 0) {
      const heights = imageRefs.current.map((ref) =>
        ref instanceof HTMLImageElement ? ref.naturalHeight : 0
      );
      const max = Math.max(...heights);
      //setMaxHeight(max);
    }
  }, [currentIndex, visibleCount]);

  const overflow = currentIndex + visibleCount > images.length;
  const visibleImages = overflow
    ? [...images.slice(currentIndex), ...images.slice(0, (currentIndex + visibleCount) % images.length)]
    : images.slice(currentIndex, currentIndex + visibleCount);

  return (
    <div className="carousel-container">
      <div className="carousel-track slide-animation" key={currentIndex}>
        {visibleImages.map((img, idx) => (
          <div className="carousel-item" key={`${img.name}-${idx}`}>
            <div
              className="image-wrapper"
              style={{ height: `${maxHeight}px` }}
            >
              <img
                ref={(el) => (imageRefs.current[idx] = el)}
                src={img.url}
                alt={img.name}
              />
            </div>
            <div className="caption">
              <h3>{img.name}</h3>
              {/* <p>{img.description}</p> */}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ImageCarousel;
